import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-download-scheduling-form',
  templateUrl: './download-scheduling-form.component.html',
  styleUrls: ['./download-scheduling-form.component.scss']
})
export class DownloadSchedulingFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
